// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.revision-status-point {
  width: 15px;
  height: 15px;
  display: inline-block;
  position: relative;
}
.revision-status-point_status_draft {
  background-color: transparent;
  border-color: transparent;
}
.revision-status-point_status_draft:before {
  content: "";
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  z-index: 1;
  top: 1px;
  left: 1px;
  width: 13px;
  height: 13px;
  z-index: 0;
  background-color: var(--g-color-base-background);
  border: 1px solid var(--g-color-line-generic-accent);
}
.revision-status-point_status_draft:after {
  content: "";
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  z-index: 1;
  background-color: var(--g-color-base-neutral-heavy);
  border: 1px solid var(--g-color-base-background);
}
.revision-status-point_status_published {
  background-color: transparent;
  border-color: transparent;
}
.revision-status-point_status_published:before {
  content: "";
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  z-index: 1;
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  z-index: 0;
  background-color: var(--g-color-base-selection-hover);
  border: 1px solid var(--g-color-base-selection-hover);
}
.revision-status-point_status_published:after {
  content: "";
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  z-index: 1;
  background-color: var(--g-color-base-brand);
  border: 1px solid var(--g-color-base-brand);
}
.revision-status-point_status_notActual {
  background-color: transparent;
  border-color: transparent;
}
.revision-status-point_status_notActual:before {
  content: "";
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  z-index: 1;
  border: 1px solid var(--g-color-line-generic-accent);
  background-color: var(--g-color-base-background);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/RevisionStatusPoint/RevisionStatusPoint.scss"],"names":[],"mappings":"AA2BA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AA1BJ;AA4BI;EACI,6BAAA;EACA,yBAAA;AA1BR;AA4BQ;EApCJ,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAGI,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAuBI,gDAAA;EACA,oDAAA;AAbZ;AAgBQ;EA1CJ,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAoCQ,mDAAA;EACA,gDAAA;AANZ;AAUI;EACI,6BAAA;EACA,yBAAA;AARR;AAUQ;EArDJ,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAUI,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAiCI,qDAAA;EACA,qDAAA;AAKZ;AAFQ;EA3DJ,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAqDQ,2CAAA;EACA,2CAAA;AAYZ;AARI;EACI,6BAAA;EACA,yBAAA;AAUR;AARQ;EAtEJ,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EAgEQ,oDAAA;EACA,gDAAA;AAkBZ","sourcesContent":[".revision-status-point {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n  position: relative;\n}\n.revision-status-point_status_draft {\n  background-color: transparent;\n  border-color: transparent;\n}\n.revision-status-point_status_draft:before {\n  content: \"\";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 7px;\n  height: 7px;\n  z-index: 1;\n  top: 1px;\n  left: 1px;\n  width: 13px;\n  height: 13px;\n  z-index: 0;\n  background-color: var(--g-color-base-background);\n  border: 1px solid var(--g-color-line-generic-accent);\n}\n.revision-status-point_status_draft:after {\n  content: \"\";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 7px;\n  height: 7px;\n  z-index: 1;\n  background-color: var(--g-color-base-neutral-heavy);\n  border: 1px solid var(--g-color-base-background);\n}\n.revision-status-point_status_published {\n  background-color: transparent;\n  border-color: transparent;\n}\n.revision-status-point_status_published:before {\n  content: \"\";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 7px;\n  height: 7px;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 15px;\n  height: 15px;\n  z-index: 0;\n  background-color: var(--g-color-base-selection-hover);\n  border: 1px solid var(--g-color-base-selection-hover);\n}\n.revision-status-point_status_published:after {\n  content: \"\";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 7px;\n  height: 7px;\n  z-index: 1;\n  background-color: var(--g-color-base-brand);\n  border: 1px solid var(--g-color-base-brand);\n}\n.revision-status-point_status_notActual {\n  background-color: transparent;\n  border-color: transparent;\n}\n.revision-status-point_status_notActual:before {\n  content: \"\";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 7px;\n  height: 7px;\n  z-index: 1;\n  border: 1px solid var(--g-color-line-generic-accent);\n  background-color: var(--g-color-base-background);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
